import HTTP from '../HTTP';

const URL_BASE = 'commun/ContactTiers/';

export default async function createAll(listeContactTiers, modeTest) {
  const mode = modeTest ? '?modeTest=true' : '?modeTest=false';
  const response = await HTTP.post(`${URL_BASE}CreateAllAsync${mode}`, listeContactTiers);
  return response;
}

export async function getAllByTiers(idTiers) {
  const response = await HTTP.get(URL_BASE + 'GetAllByTiersAsync/?TiersId=' + idTiers);
  return response;
}
